import { render, staticRenderFns } from "./RTPNetworkForm.vue?vue&type=template&id=669e9de1&"
import script from "./RTPNetworkForm.vue?vue&type=script&lang=js&"
export * from "./RTPNetworkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports